import {Injectable} from '@angular/core';

@Injectable()
export class IndomaretModel {
    public vaNumber: any;
    public productCode: any;
    public amount: any;
    public trackingRef: any;
}
